import React, { useContext } from 'react';
import axios from '../../../../axios/index';

// Context
import { UserContext } from '../../../Context/UserContextProvider';

// components
import Modal from 'react-bootstrap/Modal';

// styles
import ModalStyles from "../../DashboardReuseAbleComponents/Modal.module.css"

export default function DeleteCategoryModal(props) {
    const { userToken } = useContext(UserContext);
    const [btnLoader, setBtnLoader] = React.useState(false)

    return (
        <>
            <style type="text/css">
                {`
                .modal {
                    background: #3335;
                }

                .modal-content {
                    width: 870px;
                    border-radius: 24px;
                }

                .modal-header {
                    align-items: center !important;
                }
            `}
                {/* 
                    // height: 671px;
             */}
            </style>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton dir='rtl'>
                    <div className='w-100 d-flex align-items-start justify-content-between px-3'>
                        <div className={ModalStyles.title}>
                            حذف دسته بندی
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="w-100 d-flex align-items-center justify-content-center flex-column mt-2 mb-3">
                        <div className="d-flex align-items-center justify-content-center mt-3">
                            <svg width="45" height="45" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M7.1228 2C7.0738 1.99986 7.02526 2.0094 6.97997 2.02809C6.93467 2.04677 6.89352 2.07423 6.85887 2.10887C6.82422 2.14352 6.79677 2.18468 6.77808 2.22997C6.7594 2.27527 6.74985 2.32381 6.75 2.37281L6.75 2.375V3.50001H11.25V2.375L11.25 2.37281C11.2501 2.32381 11.2406 2.27527 11.2219 2.22997C11.2032 2.18467 11.1758 2.14352 11.1411 2.10887C11.1065 2.07423 11.0653 2.04677 11.02 2.02809C10.9747 2.0094 10.9262 1.99986 10.8772 2L10.875 2H7.125L7.1228 2ZM3.04834 5.00001L3.93604 19.2032C3.93621 19.206 3.93637 19.2088 3.93651 19.2115C3.96245 19.7163 4.29756 20 4.6875 20H13.3125C13.6986 20 14.0322 19.7226 14.0639 19.2043L14.9517 5.00001H3.04834ZM15.7431 3.50001H12.75V2.37612C12.7506 2.12977 12.7025 1.88572 12.6086 1.65798C12.5145 1.4299 12.3763 1.22267 12.2018 1.04821C12.0273 0.873754 11.8201 0.73551 11.592 0.641429C11.3643 0.547505 11.1203 0.499446 10.874 0.500005H7.12596C6.87966 0.499446 6.63567 0.547504 6.40797 0.641429C6.17989 0.735511 5.97267 0.873756 5.79821 1.04821C5.62375 1.22267 5.48551 1.4299 5.39142 1.65798C5.2975 1.88567 5.24944 2.12966 5.25 2.37596V3.50001H2.25693C2.25279 3.49997 2.24865 3.49997 2.24451 3.50001H0.75C0.335786 3.50001 0 3.83579 0 4.25001C0 4.66422 0.335786 5.00001 0.75 5.00001H1.54541L2.43872 19.293C2.50388 20.5196 3.42898 21.5 4.6875 21.5H13.3125C14.5829 21.5 15.4868 20.5109 15.5611 19.2959C15.5611 19.2958 15.5611 19.2958 15.5611 19.2958L16.4546 5.00001H17.25C17.6642 5.00001 18 4.66422 18 4.25001C18 3.83579 17.6642 3.50001 17.25 3.50001H15.7555C15.7513 3.49997 15.7472 3.49997 15.7431 3.50001ZM5.59823 6.50048C6.01218 6.4857 6.35974 6.80929 6.37452 7.22324L6.74952 17.7232C6.76431 18.1372 6.44072 18.4847 6.02677 18.4995C5.61282 18.5143 5.26526 18.1907 5.25048 17.7768L4.87548 7.27677C4.86069 6.86282 5.18428 6.51527 5.59823 6.50048ZM12.4018 6.50048C12.8157 6.51527 13.1393 6.86282 13.1245 7.27677L12.7495 17.7768C12.7347 18.1907 12.3872 18.5143 11.9732 18.4995C11.5593 18.4847 11.2357 18.1372 11.2505 17.7232L11.6255 7.22324C11.6403 6.80929 11.9878 6.4857 12.4018 6.50048ZM9 6.50001C9.41421 6.50001 9.75 6.83579 9.75 7.25001V17.75C9.75 18.1642 9.41421 18.5 9 18.5C8.58579 18.5 8.25 18.1642 8.25 17.75V7.25001C8.25 6.83579 8.58579 6.50001 9 6.50001Z" fill="#FF2B2B" />
                            </svg>
                        </div>
                        <div className="d-flex align-items-center justify-content-center mt-3">
                            <div className={ModalStyles.title}>
                                آیا از حذف دسته بندی مورد نظر مطمئن هستید؟
                            </div>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <div className='w-100 d-flex justify-content-center align-items-center mb-3'>
                        <div className={`d-flex align-items-center justify-content-center me-3 ${ModalStyles.outlined_btn}`} onClick={props.onHide}>
                            انصراف
                        </div>

                        {btnLoader ? (
                            <div className={`d-flex align-items-center justify-content-center ms-3 ${ModalStyles.filled_btn}`} >
                                <div className={ModalStyles.btn_loader_container}>
                                    <div className={ModalStyles.btn_spinner}></div>
                                </div>
                            </div>
                        )
                            : (
                                <div className={`d-flex align-items-center justify-content-center ms-3 ${ModalStyles.filled_btn}`} onClick={() => deleteHandler(props.id)}>
                                    حذف
                                </div>
                            )
                        }

                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )

    async function deleteHandler(id) {
        setBtnLoader(true)
        // if (props.subCategory) {
        const apiData = await axios.delete(
            `Category/${id}`,
            {
                headers: { 'Authorization': ` Bearer ${userToken}` },
            }
        );
        props.notify(apiData.data.metaData.message, apiData.data.isSuccess ? "success" : "error")
        if (apiData.data.isSuccess) {
            window.location.reload(false)
        }
        // } else {
        //     const apiData = await axios.delete(
        //         `Category/${id}`,
        //         {
        //             headers: { 'Authorization': ` Bearer ${userToken}` },
        //         }
        //     );
        //     props.notify(apiData.data.metaData.message, apiData.data.isSuccess ? "success" : "error")
        //     if (apiData.data.isSuccess) {
        //         window.location.reload(false)
        //     }
        // }

        setBtnLoader(false)
        props.onHide()
    }
}
